<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1 v-if="!form.id">ADD NEW DONATION SESSION</h1>
        <h1 v-else>EDIT DONATION SESSION</h1>
      </div>

      <div class="form-modal-body">

        <b-field label="Cover image">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image" @onFileSelected="(file) => {
              form.image = file;
            }
              ">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>

        <b-field label="Title" style="width: 100%">
          <b-input v-model="form.title"></b-input>
        </b-field>

        <b-field label="Description">
          <b-input v-model="form.description" maxlength="1000" type="textarea"></b-input>
        </b-field>

        <b-field label="Payment sms">
          <b-input v-model="form.payment_sms" maxlength="1000" type="textarea"></b-input>
        </b-field>

        <b-field label="Visibility" style="width: 100%">
          <b-select v-model="form.status" placeholder="Select a visibility" expanded>
            <option v-for="option in visibilities" :value="option.value" :key="option.value">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>

      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    channel: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    visibilities: [
      {
        value: "public",
        name: "Public",
      },
      {
        value: "unlisted",
        name: "Unlisted",
      },
    ],
    form: {
      id: null,
      channel_id: null,
      image: "",
      title: "",
      description: "",
      payment_sms: "",
      status: "unlisted",
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    setFormFields() {
      let vm = this;
      vm.form.id = vm.value.id;
      vm.form.channel_id = vm.value.channel_id;
      vm.form.title = vm.value.title;
      vm.form.description = vm.value.description;
      vm.form.payment_sms = vm.value.payment_sms;
      vm.form.image = vm.value.image;
      vm.form.status = vm.value.status;
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        channel_id: null,
        image: "",
        title: "",
        description: "",
        payment_sms: "",
        status: "unlisted",
      };
    },
    submitForm() {
      let vm = this;
      // Start validate
      const rules = {
        title: {
          run: (value) => {
            if (!value) {
              return "Title can not be empty";
            }
            return false;
          },
        },
        description: {
          run: (value) => {
            if (!value) {
              return "Description can not be empty";
            }
            return false;
          },
        },
        payment_sms: {
          run: (value) => {
            if (!value) {
              return "Payment sms can not be empty";
            }
            return false;
          },
        },
        image: {
          run: (value) => {
            if (!value) {
              return "Please upload a cover image";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        vm.form.channel_id = vm.channel.id;
        if (!vm.form.id) {
          vm.$store
            .dispatch("DONATE_ADDNEW_DONATION_SESSION", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("saved", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        } else {
          vm.$store
            .dispatch("DONATE_UPDATE_DONATION_SESSION", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("saved", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>
